/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckCircleOutlined = createIcon({
  name: 'icon-check-circle-outlined',
  content: '<path d="M513.59303 955.818295A446.048538 446.048538 0 0 1 197.535781 191.163659 442.225264 442.225264 0 0 1 509.769757 63.72122a446.048538 446.048538 0 0 1 446.048538 446.048537 446.048538 446.048538 0 0 1-446.048538 446.048538z m0-828.375856H509.769757a382.327318 382.327318 0 0 0 0 764.654636 382.327318 382.327318 0 0 0 382.327318-382.327318 382.327318 382.327318 0 0 0-382.327318-382.327318z"/><path d="M406.605103 656.009956l314.400497-316.503298 45.242066 44.92346L451.783447 700.933416z"/><path d="M315.420037 475.806347l180.777101 179.630118-44.92346 45.242066-180.777101-179.693839z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCheckCircleOutlined;
